export * from './cRM.service';
import { CRMService } from './cRM.service';
export * from './definitions.service';
import { DefinitionsService } from './definitions.service';
export * from './solutions.service';
import { SolutionsService } from './solutions.service';
export const APIS = [CRMService, DefinitionsService, SolutionsService];
